<div class="icon-container" [ngClass]="iconCode">
  <lib-icon [size]="size" [icon]="iconCode"></lib-icon>
</div>
